import { Component, Input, Output, EventEmitter, Renderer2, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, NgForm, } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AgentscriptService_updated } from '../../services/agent-script-service/agent-script-service';
import { KnowledgebaseComponent } from '../knowledgebase/knowledgebase.component';
import { KnowledgebaseService } from 'src/app/services/knowledgebase.service';
import { AddressDialogComponent } from '../address-dialog/address-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { StandardUIService } from 'src/app/services/standardui-service/standardui-service';
import { AppComponent } from 'src/app/app.component';
import { ApiserviceService } from 'src/app/Service/apiservice.service';
import { LocalStorageService } from 'src/app/services/localstorage-service/localstorage-service';



@Component({
  selector: 'app-agent-script',
  templateUrl: './agent-script.component.html',
  styleUrls: ['./agent-script.component.scss']
})
export class AgentScriptComponent {
  @Output() serviceTypeDetailsOutputEvent = new EventEmitter();
  @Output() bredCrumbChanges = new EventEmitter();
  @ViewChild('nextButton') nextButton: ElementRef;
  @ViewChild('previousButton') previousButton: ElementRef;
  @ViewChild('KnowledgebaseComponent') knowledgebaseComponent: KnowledgebaseComponent;

  // @Input() serviceTypeInfo: any;
  receivedData: string;
  triggerClickEvent: boolean = false;
  previousScreeInfo: any;
  previousgridview: any;
  faqkeyword: any;
  searchknowledgebase: any;
  addressObj = {
    address: '',
    address2: '',
    address_t: '',
    msr_lat: '',
    msr_lng: '',
    msr_city: '',
    msr_state: '',
    msr_zip: '',
  };
  popupResult: any=[];
  currentDate: string;

  receiveData(data: any) {
    this.receivedData = data;
    this.addressObj.address = data.address;
    this.addressObj.address2 = data.address2;
    this.addressObj.address_t = data.address_t;
    this.addressObj.msr_lat = data.msr_lat;
    this.addressObj.msr_lng = data.msr_lng;
    this.addressObj.msr_city = data.msr_city;
    this.addressObj.msr_state = data.msr_state;
    this.addressObj.msr_zip = data.msr_zip;
  }

  subq_haschild: boolean;
  selectAccordian: any = 0;
  serviceRequestArray: any;
  dataarray: any;
  agentScriptArray: any;
  subGroupItem: any = {};
  mapCenter = [-85.1392, 41.0804];
  basemapType = 'satellite';
  mapZoomLevel = 11;
  formData: any = {};
  ContactPayload: any = {};
  selectedCheckboxes: any;
  selectedValuesMap: { [colName: string]: string } = {};
  selectedValues: any;
  selectedOption: string | null = null;
  listenerFn = () => { };
  listenerpreviousFn = () => { };

  mapLoadedEvent(status: boolean) {
    // console.log('The map has loaded: ' + status);
  }
  private selectedValue: string;
  deptname: string = '';
  casetype: string = '';
  filename: any;
  qid: string = '';
  deptId: string = '';
  casetypeId: string = '';
  divId: string = '';
  agentScriptInfo: any;
  public settings = {};
  caseTypeData: any = [];
  colwidth: any = '';

  constructor(
    private StandardUIService:StandardUIService,
    private http: HttpClient,
    private agentscriptservice: AgentscriptService_updated,
    private renderer: Renderer2,
    private knowledgebase: KnowledgebaseService,
    public dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private apiservice: ApiserviceService,
    private localStorageService: LocalStorageService,
  ) {
  }
  // complex code
  insertOrUpdate(id: number, bool: any): void {
    // alert()
    // this.cartmaintenancearray
    console.log(id, bool)
    console.log(this.cartmaintenancearray)
    this.cartmaintenancearray[id] = bool
    if (this.cartmaintenancearray.includes(true)) {
      console.log("it has ticket")
      this.triggerClickEvent = true;
    }
    else
    {
      this.triggerClickEvent = false;
    }
    console.log(this.cartmaintenancearray)
  }
  cartmaintenancearray: any;
  lengthoftimes: number;
  formDataArray: any[] = [];
  createForms(selectedValue: any) {
    this.lengthoftimes = selectedValue;
    this.formDataArray = [];
    this.formDataArray = Array.from({ length: selectedValue }, () => ({}));
    this.cartmaintenancearray = Array.from({ length: selectedValue }, () => false);

  }
  iteration_id: number = 0;
  json_id: number;

  onmultiChange(event: any, item: any, iterationid: number, jsonid: number) {
    this.iteration_id = iterationid;
    this.json_id = jsonid;
    item.subq.forEach((element: any) => {
      if (element.id == jsonid) {
        if (element.hasOwnProperty("rules")) {
          element.rules.forEach((x: any) => {
            this.executeCondition(event, x, item);
          })
        }
      }
    })
  }

  displayArray: { id: number, arraydisplay: any[] }[] = [];

  checkArray(id: any, index: any) {
    const item = this.displayArray.find(obj => obj.id === id);
    if (item) {
      if (index >= 0 && index < item.arraydisplay.length) {
        return item.arraydisplay[index];
      }
      return false;
    }
  }
  updateOrCreateArray(id: any, index: number, value: boolean): void {
    let item = this.displayArray.find(obj => obj.id === id) ?? undefined;
    if (!item) {
      this.addNewEntry(id, Array(this.formDataArray.length).fill(false));
      item = this.displayArray.find(obj => obj.id === id) as { id: any, arraydisplay: boolean[] }; // Type assertion
    }
    if (index >= 0 && index < item.arraydisplay.length) {
      item.arraydisplay[index] = value;
    } else {
      const newArray = Array(index + 1).fill(false);
      for (let i = 0; i < item.arraydisplay.length; i++) {
        newArray[i] = item.arraydisplay[i];
      }
      item.arraydisplay = newArray;
      item.arraydisplay[index] = value;
    }
  }
  addNewEntry(id: any, initialArray: any[]): void {
    if (!this.displayArray.some(obj => obj.id === id)) {
      this.displayArray.push({ id, arraydisplay: initialArray });
    }
  }
  data: any;
  // end of complex code
  todaydate: any;
  tab_title:any;
  backupagentScriptInfo_filename:any
  agentscriptfilename:any;
  agentscriptInfoContent:any
  serviceTypeInfo:any
  dataInfo:any
  @Output() dataInformation=new EventEmitter();

  ngOnInit() {
    this.formData = {};
    this.initializeRadioButtons(2, []);

    this.tab_title=$(".custom-tabs li.active").find("a").attr('data-obj-title')
    this.serviceTypeInfo=this.agentscriptservice.fetchData(this.tab_title,'serviceTypeInfo')
    console.log(this.serviceTypeInfo)
    console.log(this.agentscriptservice.AlldataArray)
    console.log(this.agentscriptservice.fetchData(this.tab_title,'casetypedata'))
    // var compdata=this.agentscriptservice.fetchData(this.tab_title,'casetypedata')
    // this.dataInfo=[
    //   {
    //     "casetypename":compdata.serviceDetails.content,
    //     "divisionname":compdata.serviceDetails.division.name,
    //     "departmentname":compdata.serviceDetails.department.name
    //   }
    // ]

    this.dataInformation.emit();

    console.log(this.tab_title)
    const now = new Date();
    const year = now.getFullYear();
    const month = this.formatTwoDigits(now.getMonth() + 1);
    const day = this.formatTwoDigits(now.getDate());
    const hours = this.formatTwoDigits(now.getHours());
    const minutes = this.formatTwoDigits(now.getMinutes());

    // Format the default value as per the datetime-local input's format (YYYY-MM-DDTHH:mm)
    this.data = `${year}-${month}-${day}T${hours}:${minutes}`;
    // console.log(this.data)
    this.todaydate = new Date();
    this.currentDate = `${year}-${month}-${day}`;
    this.settings = {
      singleSelection: false,
      idField: 'valueen',
      textField: 'label',
      enableCheckAll: false,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: false,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      // itemsShowLimit: 3,
      enableSearchFilter: false,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false,
    };
    this.agentScriptInfo = this.serviceTypeInfo.serviceDetails;
    console.log("agentscriptinfodetails", this.agentScriptInfo);
    if (this.agentScriptInfo.hasOwnProperty('colwidth')) {
      this.colwidth = this.agentScriptInfo.colwidth;
      this.faqkeyword = this.agentScriptInfo.faqkeyword;
    } else {
      this.colwidth = '';
      this.faqkeyword = '';
    }
    this.casetypeId = this.agentScriptInfo.casetypeid
    console.log(this.casetypeId)
    console.log(this.agentscriptservice.getIfAssociated(this.tab_title))
      this.backupagentScriptInfo_filename=this.agentScriptInfo.filename;
      console.log(this.backupagentScriptInfo_filename)
    // if(this.agentScriptService.getIfAssociated(this.tab_title).includes(true))
    // {
    //   // alert('information ticket')
    //   this.agentscriptfilename='informationticket.json'
    //   console.log("It is associated"+this.agentscriptfilename)
    // }
    // else{
    //   this.agentscriptfilename=this.backupagentScriptInfo_filename
    //   console.log("not associated"+this.agentscriptfilename)
    // }
    this.agentscriptfilename=this.agentscriptservice.getIfAssociated(this.tab_title).includes(true)?'informationticket.json':this.agentScriptInfo.filename
    this.agentscriptInfoContent=this.agentscriptservice.getIfAssociated(this.tab_title).includes(true)?'Information Ticket':this.agentScriptInfo.content

    this.http.get<any>('/assets/json/' + this.agentscriptfilename).subscribe((data) => {
      this.agentScriptArray = data;
      setTimeout(()=>{
        //alert($(".row-agent").length);
        $(".row-agent").each((index,ele)=>{
          if((index % 2) == 0){
            //alert('even')
            $(ele).removeClass('odd').addClass('even');
          }else{
            $(ele).removeClass('even').addClass('odd');
          }
        })
      },500)
      console.log("agentscriptarraydataaaaaaaaaaa", this.agentScriptArray);
      this.agentScriptArray.forEach((data: any) => {
        if (data.disable) {
          const today = new Date();

          let daysUntilWednesday = 3 - today.getDay(); // Calculate the difference to next Wednesday (0: Sunday, 1: Monday, ..., 6: Saturday)

          if (daysUntilWednesday <= 0) {
            daysUntilWednesday += 7; // If today is Wednesday or later, calculate for the following week's Wednesday
          }


          // const nextWednesday = new Date(today);
          // nextWednesday.setDate(today.getDate() + daysUntilWednesday); // Add days to get the next Wednesday
          // const nextWednesday = new Date(today);
          // nextWednesday.setDate(today.getDate() + daysUntilWednesday);
          // const datesToShow = [this.formatDate(nextWednesday)]; // Store the next Wednesday in the array
          if (data.disable == true) {
            const nextWednesday = new Date(today);
            nextWednesday.setDate(today.getDate() + daysUntilWednesday);
            const datesToShow = [this.formatDate(nextWednesday)];
            this.dateRange = datesToShow;
          }

          if (data.disable === "day") {
            const nextWednesday = new Date(today);
            nextWednesday.setDate(today.getDate() + daysUntilWednesday);
            const options: Intl.DateTimeFormatOptions = {
              weekday: 'long'
            };
            this.dateRange = nextWednesday.toLocaleDateString('en-US', options);
            // console.log(this.dateRange)
          }
          // this.dateRange = datesToShow;
          // console.log(this.dateRange);

          const daysUntilFriday = 5 - today.getDay(); // Calculate the difference to next Friday (0: Sunday, 1: Monday, ..., 6: Saturday)
          const nextFriday = new Date(today);
          nextFriday.setDate(today.getDate() + daysUntilFriday + 7); // Add 7 days to get the next week's Friday
          const datesToShow = [this.formatDate(nextFriday)]; // Store the next Friday in the array
          this.dateRange = datesToShow;

        }

        if(this.agentscriptservice.getIfAssociated(this.tab_title).includes(true) || this.casetypeId=='296')
          {
            console.log("association is true and loaded information ticket or it is information ticket")
            console.log(data)
            if(data.type=='picklist')
            {
              console.log(data)
              this.colwidth='2'
              // data.value=this.agentScriptInfo.department.id878
              data.onload.forEach((ele:any)=>
              {
                if(this.agentScriptInfo.department.id==ele.deparmentid)
                {
                  data.value=ele.rsnforcalldeparmentid
                  this.faqkeyword=ele.faqkeyword
                }
                else if(this.agentScriptInfo.department.id == 295) 
                  {
                    this.faqkeyword="Information Ticket"
                  }
                })

            }
            console.log(this.agentScriptArray)
              // this.agentscriptservice.updateOrInsertArray(this.tab_title,'serviceTypeInfo',)

                // console.log(this.agentscriptservice.fetchData(this.tab_title, 'serviceTypeInfo'))
                // var serviceee:any
                // serviceee = this.agentscriptservice.fetchData(this.tab_title, 'serviceTypeInfo')
                // var contactDtls=serviceee.serviceDetails['contactDtls']
                // var locationDtls=serviceee.serviceDetails['locationDtls']
                // serviceee.serviceDetails= {
                //   "casetypeid": 296,
                //   "qid": 21,
                //   "division": {
                //     "id": 883,
                //     "name": "Information Ticket"
                //   },
                //   "department": {
                //     "id": 295,
                //     "name": "Information Ticket"
                //   },
                //   "imageUrl": "../../assets/images/information-ticket.svg",
                //   "filename": "informationticket.json",
                //   "content": "Information Ticket",
                //   "estimatetime":"30 Days",
                //   "colwidth":"2"
                // };
                // serviceee.serviceDetails['contactDtls']=contactDtls
                // serviceee.serviceDetails['locationDtls']=locationDtls
                // this.agentscriptservice.updateOrInsertArray(this.tab_title, 'serviceTypeInfo',serviceee)

          }
        if(data.type == "datetime"){
          if(!data.hasOwnProperty('value')){
            data.value = this.todaydate
          }
        }
        if(data.type == "date" && data.default == true){
          if(!data.hasOwnProperty('value')){
            data.value = this.currentDate;
          }
        }
        if (data.colName == "firstname"  ) {
          data.value = this.agentScriptInfo.contactDtls.firstname;
        }
        if (data.colName == "lastname" ) {
          data.value = this.agentScriptInfo.contactDtls.lastname;
        }
        if (data.colName == "phonenumber" ) {
          data.value = this.agentScriptInfo.contactDtls.phonenumber1;
        }
        if (data.colName == "email" ) {
          data.value = this.agentScriptInfo.contactDtls.emailaddress;
        }
        if (data.colName == "contactinfo"  && data.lookup == true) {
          console.log(this.agentScriptInfo.contactDtls)
          data.value = this.agentScriptInfo.contactDtls.fullcontact;
        }
        if (data.colName == "collectionday" ) {
          data.value = this.agentScriptInfo.locationDtls.collectionday;
        }
        if (data.colName == "recycleweek" ) {
          data.value = this.agentScriptInfo.locationDtls.recycleweek;
        }
        if (data.colName == "trashlocation") {
          let nextCollectionDay = this.agentScriptInfo.locationDtls.next_collection_day;
          let startIndex = nextCollectionDay.indexOf(": ") + 2;
          if (startIndex !== -1) {
            let result = nextCollectionDay.substring(startIndex);
            data.value = result;
          }
        }

      });

    });
    // this.http.get<any>('/assets/json/debriscistern.json').subscribe((data) => {
    //   this.serviceRequestArray = data;
    // });
    this.agentscriptservice.subGroupItemQuery$.subscribe((subGroupItemVal) => {
      this.subGroupItem = subGroupItemVal;
    });
    this.knowledgebase.searchEvent$.subscribe(() => {
      this.onSearchEvent();
    })
  }
  @ViewChild('dp') datepicker: BsDatepickerDirective;

  openDatepicker() {
    this.datepicker.show();
  }
  areAnyCheckboxesChecked(options: any[]): boolean {

    return options.some(option => option.checked);
  }
  dateRange: any;
  formatDate(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    return date.toLocaleDateString('en-US', options);
  }
  contactudpatedforscript:boolean=false
  openModalPopup(): void {
    const dialogRef = this.dialog.open(AddressDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      console.log(result)
      this.contactudpatedforscript=true
      this.popupResult = result;
      console.log(this.popupResult)
      this.agentScriptArray.forEach((data: any) => {
        if (data.colName == 'contactinfo' && data.lookup == true) {
          data.value = this.popupResult?.rowdata[3] + " " + this.popupResult?.rowdata[2];
          console.log(data.value);
        }
        if (data.colName == "firstname") {
          data.value = this.popupResult?.rowdata[3];
        }
        if (data.colName == "lastname") {
          data.value = this.popupResult?.rowdata[2];
        }
        if (data.colName == "phonenumber") {
          data.value = this.popupResult?.rowdata[4];
        }
        if (data.colName == "email") {
          data.value = this.popupResult?.rowdata[6];
        }
      })
    });
  }
  gotoNext(data: any, type: any) {
    this.serviceTypeDetailsOutputEvent.emit(data);
    console.log(this.agentscriptservice.AlldataArray)
    this.StandardUIService.clearlocalStorage('tabdata',this.tab_title)
    this.StandardUIService.clearlocalStorage('addressdetailscomponent',this.tab_title)
  }
  gotoPrevious(data: any, type: any, item: any) {
    this.agentscriptservice.updateOrInsertArray(this.tab_title, "isassociated", false)
    // this.agentscriptservice.updateOrInsertArray(this.tab_title, "associateddata", [])
    // console.log(data.serviceDetails.casetypeid)
    // console.log(this.previousScreeInfo.id)
    if (this.previousScreeInfo && this.previousScreeInfo.id && this.previousScreeInfo.departmentid && data.serviceDetails.casetypeid != this.previousScreeInfo.id) {
      this.loadCaseType(this.previousScreeInfo.id, this.previousScreeInfo.departmentid, item);
    } else if (this.previousgridview && this.previousgridview.casetypeid) {
      this.http.get<any>('/assets/json/dataArray.json').subscribe((dataList) => {
        let selDep: any = dataList.filter((item: any) => item.id == this.previousgridview.casetypeid);
        if (selDep.length) {
          let selDepObj = selDep[0];
          selDepObj["department"] = selDepObj.caseType && selDepObj.caseType.length && selDepObj.caseType[0].department ? selDepObj.caseType[0].department : {};
          selDepObj["division"] = selDepObj.caseType && selDepObj.caseType.length && selDepObj.caseType[0].division ? selDepObj.caseType[0].division : {};
          data.serviceDetails = selDepObj;
          // data.viewname = 'listView';
          data.viewname = this.agentscriptservice.defaultview
          this.serviceTypeDetailsOutputEvent.emit(data);
        }
      })
    } else {
      if(data && data.serviceDetails && !data.serviceDetails.contactDtls){
        data.serviceDetails = data.serviceDetails.caseTypeData;
      }
      this.serviceTypeDetailsOutputEvent.emit(data);
    }
  }
  moveNext() {
    if (this.addressObj.msr_lat && this.addressObj.msr_lng) {
      this.selectAccordian++;
    }
  }
  movePrevious() {
    this.selectAccordian--;
  }
  isRadioOptionSelected(options) {
    // console.log(options)
    if (options.value !== '') {
      // console.log(options.value)
      return true; // Value is not null or empty
    }
  }
  private formatTwoDigits(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }
  triggerSearchEvent() {
    this.knowledgebaseComponent.onSearch();
  }
  onSearchEvent(): void {
  }
  onChange(event: any, item: any) {
    setTimeout(()=>{
      //alert($(".row-agent").length);
      $(".row-agent").each((index,ele)=>{
        //alert(index);
        if((index % 2) == 0){
          //alert('even')
          $(ele).removeClass('odd').addClass('even');
        }else{
          $(ele).removeClass('even').addClass('odd');
        }
      })
    },200)
    this.cdRef.detectChanges();

    this.displayArray=[]
    if (item.type == 'checkbox') {
      console.log(item);
     if(event.target.checked){
      // const selectedOptions = item.options.filter((opt: { checked: any }) => opt.checked);
      // console.log(selectedOptions);

      // this.selectedValues = selectedOptions.map((opt: { valueen: any }) => opt.valueen);
      // console.log(this.selectedValues, 'sv')
      // if (item.colName) {
      //   this.selectedValuesMap[item.colName] = this.selectedValues.join(', ');
      //   console.log(`Selected values for ${item.colName}:`,
      //     this.selectedValuesMap[item.colName]
      //   );
      // }
      this.onItemSelect(event, item);
      return;
     }else{
      this.onDeSelect(event, item);
      return;
     }
    }

    // if(item.type == 'radio')
    // {

    // }
    console.log(event, item)
    this.selectedOption = event;
    if (item.hasOwnProperty('searchknowledgebase')) {
      item.options.forEach((objoptions): any => {
        if (objoptions.valueen == item.value) {
          this.searchknowledgebase = objoptions.label
        }
      })
      // console.log(this.faqkeyword)
    }
    else {
      this.searchknowledgebase = ''
    }
    if (this.faqkeyword) {
      let valueselected = item.value;
      const selectedOption = item.options.find((opt: { valueen: any }) => opt.valueen === valueselected);
      this.faqkeyword = selectedOption.label;
    }
    if (item.type == 'multiitems') {
      item.options.forEach((opt: any) => {
        if (opt.valueen == item.value) {
          this.createForms(opt.label)
        }
      })
    }
    if (item.type !== 'checkbox') {
      this.executerule(event, item);
    }
    const selectedOptions = item.options.filter((opt: { checked: any }) => opt.checked);
    this.selectedValues = selectedOptions.map((opt: { valueen: any }) => opt.valueen);
    if (item.colName) {
      this.selectedValuesMap[item.colName] = this.selectedValues.join(', ');
    }
    console.log("executeruleconditon before")
    this.executerule(event, item);
    if(item.colName == 'appealchannel'){
      this.agentScriptArray.forEach((ele:any) => {
        if(ele.colName == "email" ){
          ele.value=  this.agentScriptInfo.contactDtls.emailaddress
        }
        })
    }
    if(item.colName == "animalfound"){
      this.agentScriptArray.forEach((ele: any) => {
        if(ele.type == "datetime"){
          ele.value = this.todaydate
        }
      })
    }

  }

  executerule(e: any, item: any) {
    // console.log(e, item)
    if (item && item.rules && item.rules.length > 0) {
      item.rules.forEach((element: any) => {
        this.executeCondition(e, element, item);
      });
    }
  }
  executeCondition(e: any, item: any, obj: any) {
    console.log(e, 'selectedvalue');
    console.log(item)
    if (item.condition?.operator == 'equals') {
      if ((typeof e === 'boolean' || item.condition.value === e.toString()) || item.type == 'multifields') {
        this.executeThen(e, item, obj);
      }
      if ((Array.isArray(e?.target?.value) && e?.target?.value?.length === 1 && item.condition.value.includes(e?.target?.value[0])) ||
        item.condition.value == e?.target?.value || item.condition.value == e) {
        this.executeThen(e, item, obj);
      } else {
        this.executeElse(e, item, obj);
      }
    } if (item.condition.operator == 'equalsin') {
      if (
        (Array.isArray(e?.target?.value) && e?.target?.value?.length >= 1 && e?.target?.value?.every(val => item.condition.value.includes(val))) ||
        item.condition.value.includes(e?.target?.value) || item.condition.value.includes(e)
      ) {
        console.log("ëxecuterthenrulwe")
        this.executeThen(e, item, obj);
      } else {
        this.executeElse(e, item, obj);
      }
    }
    if (item.condition.operator == 'equalsinn') {
      if (
        (Array.isArray(e?.target?.value) && e?.target?.value?.length === 1 && !item.condition.value.includes(e?.target?.value[0])) ||
        (Array.isArray(e?.target?.value) && e?.target?.value?.length > 1 && e?.target?.value?.every(val => item.condition.value.includes(val))) ||
        item.condition.value.includes(e?.target?.value)
      ) {
        this.executeThen(e, item, obj);
      } else {
        this.executeElse(e, item, obj);
      }
    }
    else if (item.condition.operator == "equalsor") {
      if (this.selectedValues.includes(item.condition.value)) {
        this.executeThen(e, item, obj);
      } else {
        this.executeElse(e, item, obj);
      }
    }
    if (item.condition.operator == "multiqs") {
      item.condition.value.forEach((ele1:any) => {
        this.agentScriptArray.forEach((ele:any) => {

            if( ele.hasOwnProperty('subq'))
            {
              ele.subq.forEach((subqele:any)=>{
                if(ele1.checkid == subqele.id){
                  if(ele1.qvalue.includes(this.getColumnValueOfCart('rv_'+this.iteration_id+'_'+subqele.colName,this.iteration_id)) &&  (e?.target?.value == ele1.equals || e == ele1.equals)){
                    this.executeThen(e, item, obj);
                  }
                }
              })
            }
            else{
              if(ele1.checkid == ele.id){
                if(ele1.qvalue.includes(ele.value) &&  (e?.target?.value == ele1.equals || e == ele1.equals)){
                  this.executeThen(e, item, obj);
                }
              }
          }

        })
      })
    }
  }

  getColumnValueOfCart(columnValue: any, index: any): any {
    if (index >= 0 && index < this.formDataArray.length && this.formDataArray[index] && this.formDataArray[index].hasOwnProperty(columnValue)) {
      return this.formDataArray[index][columnValue];
    } else {
      return null; // or return a default value as per your requirement
    }
  }
  executeThen(e: any, item: any, obj: any) {
    console.log("insideexecutehten");
    item.then.forEach((res: any) => {
      if (res.action == 'show') {
        this.ifShow(e, res, this.agentScriptArray);
        // alert('656')
        // this.listenerFn();
        if(this.casetypeId!='293')
        {
          this.listenerFn();
          this.triggerClickEvent = false;

        }

      }
      if (res.action == 'hide') {
        this.ifHide(e, res, obj);
        if(this.casetypeId!='293')
        {
          this.listenerFn();
          this.triggerClickEvent = false;

        }
      }
      if (res.action == 'setvalue') {
        this.setvalue(e, res, obj);

        if(this.casetypeId!='293')
        {
          this.listenerFn();
          this.triggerClickEvent = false;
        }
      }

      if (res.action == 'click' ) {
        const eventType = 'click';
        this.listenerFn = this.renderer.listen(this.nextButton.nativeElement, eventType, () => {
          if (this.proceed) {
            this.handleButtonClick(res, item);
            this.triggerClickEvent = false; // Assuming this is necessary
          }
          else {
            return;
          }
        });
        this.triggerClickEvent = true;
      }
    });
  }
  executeElse(e: any, item: any, obj: any) {
    item.else.forEach((res: any) => {
      if (res.action == 'hide') {
        this.elseHide(e, res, obj);
      }
      if (res.action == 'show') {
        this.elseShow(e, res, obj);
      }
    });
  }
  ifShow(e: any, item: any, obj: any) {

    console.log("if show")
    if (item.id.includes('ticket')) {
      console.log(this.iteration_id)
      this.insertOrUpdate(this.iteration_id, true)
    }

    if (item.hasOwnProperty('colwidth')) {
      this.colwidth = item.colwidth;
      this.faqkeyword = item.faqkeyword;
    } else {
      this.colwidth = '';
      this.faqkeyword = '';
    }
    if (this.searchknowledgebase) {
      this.faqkeyword = this.searchknowledgebase;
      // console.log("has faqkeyword")
      this.colwidth = "2"
    }
    // if (obj.hasOwnProperty('subq')) {
    //   console.log("It has subq")
    //   obj.subq.forEach((ele: any) => {
    //     if (item.id.includes(ele.id)) {
    //       ele.visible = true;
    //     }
    //   });
    // } else {
    //   this.agentScriptArray.forEach((obj: any) => {
    //     if (item.id.includes(obj.id)) {
    //       console.log(item)
    //       console.log(item.hasOwnProperty('colwidth'))

    //       obj.value = '';
    //       obj.visible = true;
    //     }
    //   });
    // }

    if (true) {
      obj.forEach((obj: any) => {
        if (obj.hasOwnProperty('subq')) {
          this.ifShow(e, item, obj.subq)
        }
        if (item.id.includes(obj.id)) {
          this.subq_haschild = true;
          if (this.subq_haschild && obj.extra) {
            obj.value=""
            this.updateOrCreateArray(obj.id, this.iteration_id, true);
            this.subq_haschild = false;
          }
          if (obj.type === 'radio') {
            this.formSubmitted = false;
          }
          obj.value = '';
          obj.visible = true;
          if (obj.type == 'mcheckbox') {
            // console.log("hide is checkbox")
            console.log(obj)
            // obj.checked=false;
            obj.options.forEach((x: any) => {
              x.checked = false;
            })
          }
        }
      });
    }
    setTimeout(()=>
      {
        // alert()
        // alert($(".questionclass").parents(".parentrow").length)
      $(".questionclass").parents(".testclass").addClass("oddeven")
      $(".questionclass").parents(".testclass").addClass("row-agent")

      // setTimeout(()=>{
        //alert($(".row-agent").length);
        $(".row-agent").each((index,ele)=>{
          //alert(index);
          if((index % 2) == 0){
            //alert('even')
            $(ele).removeClass('odd').addClass('even');
          }else{
            $(ele).removeClass('even').addClass('odd');
          }
        })
      // },200)

      },100)
  }
  elseShow(e: any, item: any, obj: any) {
    console.log("else show")
    // if (obj.hasOwnProperty('subq')) {
    //   obj.subq.forEach((ele: any) => {
    //     if (item.id.includes(ele.id)) {
    //       ele.visible = true;
    //     }
    //   });
    // } else {
    //   this.agentScriptArray.forEach((obj: any) => {
    //     if (item.id.includes(obj.id)) {
    //       console.log('elseShow sub', obj.visible);
    //       obj.visible = true;
    //     }
    //   });
    // }

    if (obj.hasOwnProperty('subq')) {
      this.agentScriptArray.forEach((obj: any) => {
        if (obj.type == 'multifields') {
          obj.subq.forEach((ele: any) => {
            if (item.id.includes(ele.id)) {
              ele.visible = true;
              this.updateOrCreateArray(ele.id, this.iteration_id, true);
            }
          })
        }
      });

    } else {
      this.agentScriptArray.forEach((obj: any) => {
        if (item.id.includes(obj.id)) {
          obj.visible = true;
        }
      });
    }
    setTimeout(()=>
      {
        // alert()
        // alert($(".questionclass").parents(".parentrow").length)
      $(".questionclass").parents(".testclass").addClass("oddeven")
      $(".questionclass").parents(".testclass").addClass("row-agent")

      // setTimeout(()=>{
        //alert($(".row-agent").length);
        $(".row-agent").each((index,ele)=>{
          //alert(index);
          if((index % 2) == 0){
            //alert('even')
            $(ele).removeClass('odd').addClass('even');
          }else{
            $(ele).removeClass('even').addClass('odd');
          }
        })
      // },200)

      },100)
  }

  initializeRadioButtons(optId: number, options: any[]) {
    this.formData[optId] = {};
    options.forEach((option, index) => {
      this.formData[optId][index] = { checked: false };
    });
  }

  changeRadioButtonState(optId: number, index: number, newState: boolean) {
    this.formData[optId][index].checked = newState;
  }
  // formData: any = {};
  updateValue(index: number, key: string, newValue: any): void {
    console.log(this.formDataArray)
    // Check if the index is valid and the object at that index has the specified key
    if (index >= 0 && index < this.formDataArray.length && this.formDataArray[index].hasOwnProperty(key)) {
        // Update the value of the specified key
        this.formDataArray[index][key] = newValue;
    } else {
        // Handle the case where the key doesn't exist or the index is out of range
        console.log('Invalid index or key does not exist.');
    }
}
  ifHide(e: any, item: any, obj: any) {
    console.log("if hide")
    if (item.id.includes('ticket')) {
      console.log(this.iteration_id)
      this.insertOrUpdate(this.iteration_id, false)
    }
    if (item.hasOwnProperty('colwidth')) {
      this.colwidth = item.colwidth;
    } else {
      this.colwidth = '';
    }
    if (this.searchknowledgebase) {
      this.faqkeyword = this.searchknowledgebase
      // console.log("has faqkeyword")
      this.colwidth = "2"
    }
    // if (obj.hasOwnProperty('subq')) {
    //   obj.subq.forEach((ele: any) => {
    //     if (item.id.includes(ele.id)) {
    //       ele.visible = false;
    //     }
    //   });
    // } else {
    //   this.agentScriptArray.forEach((obj: any) => {
    //     if (item.id.includes(obj.id )) {

    //       console.log('ifHide not sub', obj.visible);
    //       obj.value = '';
    //       obj.visible = false;
    //     }

    //   });
    // }
    if (obj.hasOwnProperty('subq')) {

      this.agentScriptArray.forEach((obj: any) => {
        if (obj.type == 'multifields') {
          obj.subq.forEach((ele: any) => {
            if (item.id.includes(ele.id)) {
              ele.value = '';
              ele.visible = false;
              this.updateOrCreateArray(ele.id, this.iteration_id, false);
              // if (ele.type.includes('mcheckbox')) {
              //   console.log("hide is checkbox")
              //   console.log(ele)
                // ele.checked=false;
                this.updateValue(this.iteration_id, 'rv_'+this.iteration_id+'_'+ele.colName, '')

                ele.options.forEach((x: any) => {
                  x.checked=false
                  // options.forEach((option, index) => {
                    // var kk=this.iteration_id+1
                    // this.formData[ele.id][this.iteration_id] = { checked: false };
                  // });
                  // this.changeRadioButtonState(this.iteration_id, ele.colName, false); // Change the first radio button's checked state to false
                  // x.checked = false;
                  // ele.options[2].checked = false;
                  // "rv_' + i + '_' + opt.colName"=false
                  // x.value=''
                  // this.formData['rv_' + this.iteration_id + '_' + ele.colName] = null
                 })
              // }
            }
          })
        }
      });
    } else {
      this.agentScriptArray.forEach((obj: any) => {
        if (item.id.includes(obj.id)) {
          obj.value = '';
          obj.visible = false;
          if (obj.type == 'checkbox') {
            console.log("hide is checkbox")
            console.log(obj)
            // obj.checked=false;
            obj.options.forEach((x: any) => {
              x.checked = false;
            })
          }
        }
      });
    }

    setTimeout(()=>
      {
        // alert($(".questionclass").parents(".parentrow").length)
      // $(".questionclass").parents(".testclass").addClass("oddeven")
      // $(".questionclass").parents(".testclass").addClass("row-agent")

      // alert((!($(".testclass .parentrow ").length < 0)))

    //   $(".testclass").not(":has(.parentrow)").each(function() {
    //     console.log($(this));
    // });

    $(".testclass").not(":has(.parentrow)").removeClass("oddeven row-agent odd");


      // alert(($(".testclass").children(".parentrow").length )+"line is 1023")
      // if (($(".testclass").children(".parentrow").length < 0)) {
      //   // alert()
      //     alert($(".questionclass").parents(".parentrow").length+"line is 1026")
      //   $(".testclass").removeClass("oddeven row-agent odd ");
      // }

      // setTimeout(()=>{
      //   //alert($(".row-agent").length);
      //   $(".row-agent").each((index,ele)=>{
      //     //alert(index);
      //     if((index % 2) == 0){
      //       //alert('even')
      //       $(ele).removeClass('odd,even')
      //     }else{
      //       $(ele).removeClass('even')
      //     }
      //   })
      // },200)

      },100)

  }
  elseHide(e: any, item: any, obj: any) {
    console.log("else hide")
    // if (obj.hasOwnProperty('subq')) {
    //   obj.subq.forEach((ele: any) => {
    //     if (item.id.includes(ele.id)) {
    //       ele.visible = false;
    //     }
    //   });
    // } else {
    //   this.agentScriptArray.forEach((obj: any) => {
    //     if (item.id.includes(obj.id)) {
    //       obj.value = '';
    //       obj.visible = false;
    //     }
    //   });
    // }
    if (true) {
      this.agentScriptArray.forEach((obj: any) => {
        if (obj.type == 'multifields') {
          // obj.forEach((ele:any)=>{
          obj.subq.forEach((ele_subq: any) => {
            if (ele_subq.hasOwnProperty('haschild')) {
              ele_subq.subq.forEach((haschild: any) => {
                if (item.id.includes(haschild.id)) {
                  this.updateOrCreateArray(haschild.id, this.iteration_id, false);
                }
              })
            }
            else {
              if (item.id.includes(ele_subq.id)) {
                ele_subq.visible = true;
              }
            }
          })
        }
        if (item.id.includes(obj.id)) {
          obj.visible = false;
        }
      });

      setTimeout(()=>
        {
        // $(".questionclass").parents(".testclass").addClass("oddeven")
        // $(".questionclass").parents(".testclass").addClass("row-agent")

        // alert(($(".testclass").children(".parentrow").length)+"line is 1091")
        // if (($(".testclass").children(".parentrow").length < 0)) {
        //   alert($(".questionclass").parents(".parentrow").length+"line is 1093")

        //   $(".testclass").removeClass("oddeven row-agent");
        // }

        $(".testclass").not(":has(.parentrow)").removeClass("oddeven row-agent odd");

        // setTimeout(()=>{
        //   //alert($(".row-agent").length);
        //   $(".row-agent").each((index,ele)=>{
        //     //alert(index);
        //     if((index % 2) == 0){
        //       //alert('even')
        //       $(ele).removeClass('odd').addClass('even');
        //     }else{
        //       $(ele).removeClass('even').addClass('odd');
        //     }
        //   })
        // },200)
        },100)
    }
  }

  onInput(value: string, item: any): void {
      if (typeof value === 'string') {
        let trimmedValue = value.trim(); // Trim the value
        let isNotEmpty = trimmedValue !== '';
        this.executerule(isNotEmpty, item);
      }

  }

  // maxlengtherror(value: string, data: any, control: any) {
  //   if (value.length > data.charlength) {
  //     control.control.setErrors({ maxlength: `The maximum length of ${data.charlength} characters has been reached.` });
  //   } else {
  //     control.control.setErrors(null);
  //   }
  // }
//   maxlengtherror(value: string, data: any, control: any) {
//     const currentErrors = control.control.errors || {};

//     if (value.length > data.charlength) {
//         currentErrors['maxlength'] = `The maximum length of ${data.charlength} characters has been reached.`;
//         control.control.setErrors(currentErrors);
//     } else {
//         if (currentErrors.hasOwnProperty('maxlength')) {
//             delete currentErrors['maxlength'];
//             // If there are no more errors, set errors to null
//             if (Object.keys(currentErrors).length === 0) {
//                 control.control.setErrors(null);
//             } else {
//                 control.control.setErrors(currentErrors);
//             }
//         }
//     }
// }
  proceed: boolean;
  onsubmitnext(form: NgForm) {
    console.log("in submit next")

    if (this.casetypeId == '293' && this.cartmaintenancearray?.includes(true)) {
      if (form.valid) {
        this.proceed = true;
        this.formSubmitted = true;
      }
      else {
        this.proceed = false;
        this.formSubmitted = true;
        this.markAllControlsAsTouched(form);
      }

    }
    else{
      //this.serviceTypeInfo.serviceDetails = []
    if (form.valid) {
      this.proceed = true;
      this.formSubmitted = true;
    }
    else {
      this.proceed = false;
      this.formSubmitted = true;
      this.markAllControlsAsTouched(form);
    }
    }

  }
  IncidentPayload: any = {}; // Declare IncidentPayload at the class level
  setDepartmentValue(serviceCategoryId: string): void {
    const selectedServiceCategory = this.findItemById(
      serviceCategoryId,
      this.serviceRequestArray
    );
    if (selectedServiceCategory) {
      // Use the label or any other property to set the department value
      this.IncidentPayload['Incident.department'] = selectedServiceCategory.label;
    }
  }
  formSubmitted = false;
  // countInvalidFields(form: NgForm): number {
  //   let count = 0;
  //   Object.values(form.controls).forEach((control) => {
  //     if (control.invalid && control.touched) {
  //       count++;
  //     }
  //   });
  //   return count;
  // }
  countInvalidFields(form: NgForm): number {
    let count = 0;
    const controls = form.controls;

    Object.keys(controls).forEach(controlName => {
      const control = controls[controlName];

      if (control.invalid && (control.dirty || control.touched)) {
        count++;
      }
    });

    return count;
  }
  AddfieldsPayload: any = {};
  cartfieldsPayload: any = {};
username:any;
  OnSubmit(form: NgForm) {
    this.IncidentPayload={}
    this.agentscriptservice.updateOrInsertArray(this.tab_title,'scriptdata',[])
    this.agentscriptservice.updateOrInsertArray(this.tab_title,'scriptpayloaddata',[])


    console.log(this.agentscriptservice.AlldataArray)

    this.serviceTypeInfo=this.agentscriptservice.fetchData(this.tab_title,'serviceTypeInfo')
    console.log(this.serviceTypeInfo)
    console.log(form)
    console.log(form.value)

    this.agentscriptservice.updateOrInsertArray(this.tab_title,'scriptdata',form.value)
    console.log(this.agentscriptservice.fetchData(this.tab_title,'scriptdata'))

    console.log()
    // console.log("Ref no is"+$(".custom-tabs li.active").find("a").attr('data-obj-title'))
    // this.IncidentPayload['Incident.refno'] =$(".custom-tabs li.active").find("a").attr('data-obj-title')
    // console.log(this.serviceTypeInfo.serviceDetails)
     console.log(this.caseTypeData)
    // console.log(this.caseTypeData.length)
    // if (this.caseTypeData.length != 0) {
    //   // console.log("yess")
    //   this.serviceTypeInfo.serviceDetails = this.serviceTypeInfo.serviceDetails?.caseTypeData
    // }
    this.caseTypeData = []
    let currentDate = new Date();
    // console.log(this.serviceTypeInfo.serviceDetails)
    // this.serviceTypeInfo.serviceDetails=this.serviceTypeInfo.serviceDetails?.caseTypeData

    this.caseTypeData = this.serviceTypeInfo.serviceDetails;
    console.log("casetypedataaaaaaaaaaaaa",this.caseTypeData);
    for(let i in form.value ){
      console.log(this.caseTypeData.contactDtls)
      if(i == 'contactinfo'  && this.caseTypeData && this.caseTypeData.contactDtls && this.caseTypeData.contactDtls.fullcontact && this.caseTypeData.casetypeid!='211'){
        this.caseTypeData.contactDtls.fullcontact = form.value[i];
    }
    if(i == 'firstname'  && this.caseTypeData && this.caseTypeData.contactDtls && this.caseTypeData.contactDtls.firstname){
      this.caseTypeData.contactDtls.firstname = form.value[i];
    }
    if(i == 'lastname' && this.caseTypeData && this.caseTypeData.contactDtls && this.caseTypeData.contactDtls.lastname){
      this.caseTypeData.contactDtls.lastname = form.value[i];
    }
    if(i == 'phonenumber'  && this.caseTypeData && this.caseTypeData.contactDtls && this.caseTypeData.contactDtls.hasOwnProperty('phonenumber1')){
      this.caseTypeData.contactDtls.phonenumber1 = form.value[i];
    }
    // if(i == 'phonenumber'  && this.caseTypeData && this.caseTypeData.contactDtls && this.caseTypeData.contactDtls.hasOwnProperty('phonenumber1')){
    //   this.caseTypeData.contactDtls.phonenumber1 = form.value[i];
    // }
    // if(i == 'phonenumber'  && this.caseTypeData && this.caseTypeData.contactDtls && this.caseTypeData.contactDtls.hasOwnProperty('phonenumber1')){
    //   this.caseTypeData.contactDtls.phonenumber1 = form.value[i];
    // }
    if(i == 'email'  && this.caseTypeData && this.caseTypeData.contactDtls && this.caseTypeData.contactDtls.hasOwnProperty('emailaddress')){
      this.caseTypeData.contactDtls.emailaddress = form.value[i];
      if(this.caseTypeData.contactDtls.emailaddress == 'anonymous@thesmartcity311.com')
        {
          this.caseTypeData.contactDtls.anonymous=true
          this.caseTypeData.contactDtls.contactid=11
        }
        else
        {
          this.caseTypeData.contactDtls.contactid=(Object.keys(this.popupResult).length != 0 && this.popupResult?.rowdata[1])?this.popupResult?.rowdata[1]:this.caseTypeData.contactDtls.contactid
          this.caseTypeData.contactDtls.anonymous=false

        }
    }
    if(this.contactudpatedforscript && Object.keys(this.popupResult).length != 0)
      {
        if( this.caseTypeData && this.caseTypeData.contactDtls && this.caseTypeData.contactDtls.hasOwnProperty('phonenumber2')){
          console.log(this.popupResult)
          // console.log(this.popupResult?.rowdata[5])

          this.caseTypeData.contactDtls.phonenumber2 =(this.popupResult.hasOwnProperty('rowdata') && this.popupResult?.rowdata[5])?this.popupResult?.rowdata[5]:''
        }
        if( this.caseTypeData && this.caseTypeData.contactDtls && this.caseTypeData.contactDtls.hasOwnProperty('emailalt1')){
          this.caseTypeData.contactDtls.emailalt1 = (this.popupResult.hasOwnProperty('rowdata') &&this.popupResult?.rowdata[7])?this.popupResult?.rowdata[7]:''
        }
        if( this.caseTypeData && this.caseTypeData.contactDtls && this.caseTypeData.contactDtls.hasOwnProperty('street')){
          this.caseTypeData.contactDtls.street = (this.popupResult.hasOwnProperty('rowdata') &&this.popupResult?.rowdata[9])?this.popupResult?.rowdata[9]:this.caseTypeData.contactDtls.street
        }
        if( this.caseTypeData && this.caseTypeData.contactDtls && this.caseTypeData.contactDtls.hasOwnProperty('city')){
          this.caseTypeData.contactDtls.city = (this.popupResult.hasOwnProperty('rowdata') &&this.popupResult?.rowdata[10])?this.popupResult?.rowdata[10]:this.caseTypeData.contactDtls.city
        }
        if( this.caseTypeData && this.caseTypeData.contactDtls && this.caseTypeData.contactDtls.hasOwnProperty('postalcode')){
          this.caseTypeData.contactDtls.postalcode = (this.popupResult.hasOwnProperty('rowdata') &&this.popupResult?.rowdata[11])?this.popupResult?.rowdata[11]:this.caseTypeData.contactDtls.postalcode
        }
        if( this.caseTypeData && this.caseTypeData.contactDtls && this.caseTypeData.contactDtls.hasOwnProperty('country')){
          this.caseTypeData.contactDtls.country = (this.popupResult.hasOwnProperty('rowdata') &&this.popupResult?.rowdata[12])?this.popupResult?.rowdata[12]:this.caseTypeData.contactDtls.country
        }
        if( this.caseTypeData && this.caseTypeData.contactDtls && this.caseTypeData.contactDtls.hasOwnProperty('mailingadd')){
          this.caseTypeData.contactDtls.mailingadd = ((this.popupResult.hasOwnProperty('rowdata') &&this.popupResult?.rowdata[9])?this.popupResult?.rowdata[9]:'')+((this.popupResult.hasOwnProperty('rowdata') &&this.popupResult?.rowdata[10])?'\n'+this.popupResult?.rowdata[10]+' IN':'')+((this.popupResult.hasOwnProperty('rowdata') &&this.popupResult?.rowdata[11])?' '+'\n'+this.popupResult?.rowdata[11]:'')+((this.popupResult.hasOwnProperty('rowdata') &&this.popupResult?.rowdata[12])?' '+' '+this.popupResult?.rowdata[12]:'')
        }
      }
    if(i == 'collectionday'  && this.caseTypeData && this.caseTypeData.contactDtls && this.caseTypeData.contactDtls.hasOwnProperty('collectionday')){
      this.caseTypeData.locationDtls.collectionday = form.value[i];
    }
    if(i == 'recycleweek'  && this.caseTypeData && this.caseTypeData.contactDtls && this.caseTypeData.contactDtls.hasOwnProperty('recycleweek')){
      this.caseTypeData.locationDtls.recycleweek = form.value[i];
    }
    if (i == 'trashlocation' && this.caseTypeData && this.caseTypeData.locationDtls && this.caseTypeData.locationDtls.next_collection_day) {
      let nextCollectionDay = this.caseTypeData.locationDtls.next_collection_day;
      let startIndex = nextCollectionDay.indexOf(": ") + 2;
      if (startIndex !== -1) {
        let result = nextCollectionDay.substring(startIndex);
        result = form.value[i];
      }
    }

    }

    this.IncidentPayload["refno"] = $(".custom-tabs li.active").find("a").attr('data-obj-title')
    if (this.casetypeId == '304') {
      var length_of_times = this.lengthoftimes
      while (length_of_times > 0) {


        var k = length_of_times - 1;
        this.IncidentPayload["pet" + length_of_times + "name"] = form.value['rv_' + k + '_name'];
        this.IncidentPayload["pet" + length_of_times + "tagnumber"] = form.value['rv_' + k + '_tag_numbers'];

        if (typeof (form.value) === 'object' && form.value !== null) {
          // console.log(form.controls)
          // console.log(form.value)
          // console.log(form.value.controlName)
          const selectedValues = form.value['rv_' + k + '_reporting_compliance_for'] as any[];
          const extractedValues = selectedValues.map(value => value.valueen);
          const commaSeparatedValues = extractedValues.join(', ');
          var L = k + 8;
          this.IncidentPayload["componentfield" + L] = commaSeparatedValues;
        }


        // this.IncidentPayload["Incident.pet"+this.lengthoftimes+"name"] = form.value['rv_' + k + '_name'];
        length_of_times--;
      }
      console.log("It is pet/reg")
      console.log("No selected is", this.lengthoftimes)
    }

    if (this.casetypeId == '293' && this.agentScriptInfo.department.id == '207') {
      console.log("in sw_cartmaintenance")
      var length_of_times = this.lengthoftimes
      // this.AddfieldsPayload['Cart.numberofvehicles']=length_of_times;
      this.cartfieldsPayload["numberofbarrels"] = length_of_times
      console.log(form.value)
      while (length_of_times > 0) {

        var k = length_of_times - 1;
        this.cartfieldsPayload["sizeofcart" + length_of_times] = +form.value['rv_' + k + '_sizeofcart'];
        this.cartfieldsPayload["garbagerecyling" + length_of_times] = +form.value['rv_' + k + '_garbagerecyling'];
        this.cartfieldsPayload["requestreason" + length_of_times] = +form.value['rv_' + k + '_requestreason'];
        this.cartfieldsPayload["streetmissed" + length_of_times] = form.value['rv_' + k + '_streetmissed'];
        this.cartfieldsPayload["witnessoption" + length_of_times] = form.value['rv_' + k + '_witnessoption'];
        this.cartfieldsPayload["lookedproperty" + length_of_times] = form.value['rv_' + k + '_lookedproperty'];
        this.cartfieldsPayload["cartemptyatthecurb" + length_of_times] = form.value['rv_' + k + '_cartemptyatthecurb'];
        this.cartfieldsPayload["itemtype" + length_of_times] = +form.value['rv_' + k + '_itemtype'];
        this.cartfieldsPayload["brokenmeter" + length_of_times] = form.value['rv_' + k + '_brokenmeter'];
        this.cartfieldsPayload["hitorsign" + length_of_times] = form.value['rv_' + k + '_hitorsign'];
        this.cartfieldsPayload["blockingcitycrews" + length_of_times] = form.value['rv_' + k + '_blockingcitycrews'];
        this.cartfieldsPayload["listreasonforpickup" + length_of_times] = form.value['rv_' + k + '_listreasonforpickup'];
        // this.AddfieldsPayload["Cart.vehicle" + length_of_times + "color"] = +form.value['rv_' + k + '_vehiclecolor'];
        // this.AddfieldsPayload["Cart.vehicle" + length_of_times + "makemodel"] = +form.value['rv_' + k + '_vehiclemakemodel'];

        length_of_times--;
      }
      console.log(this.cartfieldsPayload)
      var filteredcartfields=this.filterEmptyValues(this.cartfieldsPayload)
      this.cartfieldsPayload=filteredcartfields
      console.log(this.cartfieldsPayload)
    }

    if (this.casetypeId == '211' && this.agentScriptInfo.department.id == '199') {
      console.log("in ncc_abandonedvehicles")
      var length_of_times = this.lengthoftimes
      this.AddfieldsPayload['numberofvehicles'] = length_of_times;
      while (length_of_times > 0) {

        var k = length_of_times - 1;
        this.AddfieldsPayload["vehiclelocation" + length_of_times] = +form.value['rv_' + k + '_vehiclelocation'];
        this.AddfieldsPayload["vehicleparked" + length_of_times] = +form.value['rv_' + k + '_parked'];
        this.AddfieldsPayload["vehicletype" + length_of_times] = +form.value['rv_' + k + '_vehicletype'];
        this.AddfieldsPayload["vehicle" + length_of_times + "color"] = form.value['rv_' + k + '_vehiclecolor'];
        this.AddfieldsPayload["vehicle" + length_of_times + "makemodel"] = form.value['rv_' + k + '_vehiclemakemodel'];

        length_of_times--;
      }
      console.log(this.AddfieldsPayload)

      // this.AddfieldsPayload=this.filterEmptyValues(this.AddfieldsPayload)
      // console.log(this.AddfieldsPayload)
    }
    if (form.valid) {
      this.formSubmitted = true;
      for (const controlName in form.controls) {
        if (form.controls.hasOwnProperty(controlName)) {
          // console.log(controlName)
          const control = form.controls[controlName];
          if ((control.valid) || (controlName == 'specificdatetime')) {
            // console.log(controlName)
            const dataObj = this.agentScriptArray.find((item) => item.colName === controlName);
            // console.log(dataObj)
            if (dataObj) {
              console.log(controlName, dataObj.value)
              if (dataObj.type === 'multipicklist' || dataObj.type === "checkbox") {
                const selectedValues = dataObj.value as any[];
                // const extractedValues = selectedValues.map(value => value.valueen);
                const commaSeparatedValues = selectedValues.join(', ');
                this.IncidentPayload[controlName] = commaSeparatedValues;
              }
              else if (dataObj.type === 'datetime' || dataObj.type === 'date') {
                // console.log("It is datetime")
                // 09-02-2024
                const specificDateTime = control.value as string;
                const dateObj = new Date(specificDateTime);
                this.IncidentPayload[controlName] = dateObj.getTime();
              }
              // else if (dataObj.type === 'radio') {
              //   // const specificDateTime = control.value as string;
              //   // const dateObj = new Date(specificDateTime);
              //   this.IncidentPayload[controlName] = control.value;
              // }
              else if (dataObj.type === 'checkbox') {
                // IncidentPayload['Incident.componentfield']=this.selectedValuesMap['open_structure_secure[]']
                // const specificDateTime = control.value as string;
                // const dateObj = new Date(specificDateTime);
                // this.IncidentPayload[controlName] = control.value;
                this.IncidentPayload[controlName] = this.selectedValuesMap[controlName];
              }
              else {
                this.IncidentPayload[controlName] = control.value;
              }

            }
          }
        }
      }
      // this.IncidentPayload['sla'] = currentDate.setDate(currentDate.getDate() + 4);
      // let payLoad = [
      //   {
      //     "entityName": "Incident",
      //     "payLoad": this.IncidentPayload
      //   }
      // ]
      // console.log(this.serviceTypeInfo?.serviceDetails?.locationDtls)
      console.log(this.IncidentPayload)
      console.log(this.serviceTypeInfo)
      console.log(this.serviceTypeInfo?.serviceDetails.locationDtls)
      var agentScriptSaveData = {
        tabname: $(".custom-tabs li.active").find("a").attr('data-obj-title'),
        caseTypeData: this.caseTypeData,
        addfields: this.AddfieldsPayload,
        cart: this.cartfieldsPayload,
        // tab_id:$(".custom-tabs li.active").find("a").attr('data-obj-id'),
        formScriptData: Object.assign(this.IncidentPayload, this.serviceTypeInfo?.serviceDetails.locationDtls)
      }
      console.log(agentScriptSaveData)

      this.username=JSON.parse(this.localStorageService.get('currentUser')).email;
      const updatedPayload = { ...agentScriptSaveData, username: this.username };
      this.apiservice.updatelogs(updatedPayload).subscribe((data:any)=>
      {
     console.log(data);
      });
      this.agentscriptservice.updateOrInsertArray(this.tab_title,'scriptpayloaddata',[])
      this.agentscriptservice.updateOrInsertArray(this.tab_title,'scriptpayloaddata',{ viewname: 'agentscriptView', 'serviceDetails': agentScriptSaveData, isSubmit: true })
      this.gotoNext({ viewname: 'agentscriptView', 'serviceDetails': agentScriptSaveData, isSubmit: true }, 0);
      console.log(this.agentscriptservice.AlldataArray)

    } else {
      this.formSubmitted = true;
      this.markAllControlsAsTouched(form);
    }
  }

  filterEmptyValues(obj: any): any {
    const filteredObject: any = {};
    Object.keys(obj).forEach(key => {
      if (obj[key] != "" && !Number.isNaN(obj[key])  && obj[key] != null && obj[key] != undefined && obj[key] != 'null') {
        filteredObject[key] = obj[key];
      }
    });
    return filteredObject;
  }

  markAllControlsAsTouched(formGroup: NgForm | any) {
    Object.keys(formGroup.controls).forEach(controlName => {
      const control = formGroup.controls[controlName];
      control.markAsTouched();
      if (control.controls) {
        this.markAllControlsAsTouched(control);
      }
    });
  }
  isControlInvalid(controlName: string, form: NgForm): boolean {
    const control = form.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }
  findItemById(id: string, itemList: any[]): any {
    for (const item of itemList) {
      if (item.id === id) {
        return item;
      } else if (item.subgroup) {
        const subItem = this.findItemById(id, item.subgroup);
        if (subItem) {
          return subItem;
        }
      }
    }
    return null;
  }

  ///////casetype/////////////////////////
  handlePreviousButtonClick(res: any, departmentid: any, data: any, item: any) {
    if (res.hasOwnProperty('colwidth')) {
      this.colwidth = res.colwidth;
      this.faqkeyword = res.faqkeyword;
    }
    if (res.id && res.departmentid) {
      this.loadCaseType(res.id, res.departmentid, item, { ...res })
    }
    else {
      this.colwidth = '';
      this.faqkeyword = '';
      this.serviceTypeDetailsOutputEvent.emit(data);
      this.gotoNext({ viewname: 'addressView', 'serviceDetails': this.serviceTypeInfo }, 0);
    }
  }
  handleButtonClick(res: any, item: any) {
    if (res.hasOwnProperty('colwidth')) {
      this.colwidth = res.colwidth;
      this.faqkeyword = res.faqkeyword;
    } else {
      this.colwidth = '';
      this.faqkeyword = '';
    }
    this.previousScreeInfo = {};
    this.previousgridview = {};
    if (res.hasOwnProperty('previousgridview')) {
      this.previousgridview = res.previousgridview;
    }
    if (res.hasOwnProperty('previous')) {
      this.previousScreeInfo = res.previous;
      this.listenerpreviousFn();
      this.renderer.listen(this.previousButton.nativeElement, 'click', () => {
        this.colwidth = '';
        this.handlePreviousButtonClick(res.previous, res.departmentid, res.data, item);
      });
    }
    if (res.type == 'showcasetype') {
      this.loadCaseType(res.id[0], res.departmentid, item)
    }
  }
  loadCaseType(id: any, departmentid: any, item: any, res:any={}) {
    console.log("asdsasdsdfdasdasdsd",res)
    this.http.get<any>('/assets/json/dataArray.json').subscribe((data) => {
      this.loadCaseTypeScript(data, id, departmentid, item,res);
    });
  }

  // loadCaseTypeScript(data: any, casetypeid: any, departmentid: any) {
  //   for (let i = 0; i < data.length; i++) {
  //     if (data[i].hasOwnProperty('casetypeid') && data[i].casetypeid == casetypeid && data[i].department.id == departmentid) {
  //       this.casetypeId = data[i].casetypeid;
  //       this.agentScriptInfo = data[i];
  //       data[i]['locationDtls'] = this.serviceTypeInfo.serviceDetails.locationDtls;
  //       data[i]['contactDtls'] = this.serviceTypeInfo.serviceDetails.contactDtls;
  //       data[i]['caseType'] = data;
  //       this.serviceTypeInfo = { "serviceDetails" : data[i] };
  //       this.bredCrumbChanges.emit(this.serviceTypeInfo.serviceDetails);
  //       this.http.get<any>('/assets/json/' + data[i].filename).subscribe((data) => {
  //         this.agentScriptArray = data;
  //       });
  //       continue;
  //     }
  //     if (data[i].caseType) {
  //       this.loadCaseTypeScript(data[i].caseType, casetypeid, departmentid);
  //     }
  //   }
  // }
  loadCaseTypeScript(data: any, casetypeid: any, departmentid: any, item: any,res) {
    console.log("res value:", res);
    // console.log(item)
    // data[i].hasOwnProperty('casetypeid') ||  data[i].hasOwnProperty('casesubtypeid')   &&
    // data[i].casetypeid == casetypeid ||  data[i].casesubtypeid == casetypeid &&
    // data[i].department.id == departmentid
    for (let i = 0; i < data.length; i++) {
      if (
      (data[i].casetypeid == casetypeid || data[i].casesubtypeid == casetypeid) && data[i].department.id == departmentid
      ) {
        console.log(this.agentscriptservice.fetchData(this.tab_title,'casetypedata'))
        console.log(this.agentscriptservice.fetchData(this.tab_title,'serviceTypeInfo'))
        this.casetypeId = data[i].casetypeid;
        data[i]['locationDtls'] = this.serviceTypeInfo.serviceDetails.locationDtls ? this.serviceTypeInfo.serviceDetails.locationDtls : this.agentScriptInfo.locationDtls;
        data[i]['contactDtls'] = this.serviceTypeInfo.serviceDetails.contactDtls ? this.serviceTypeInfo.serviceDetails.contactDtls : this.agentScriptInfo.contactDtls;
        // data[i]['caseType'] = data;
        this.serviceTypeInfo = { serviceDetails: data[i] };
        this.agentScriptInfo = data[i];
        this.bredCrumbChanges.emit(this.serviceTypeInfo.serviceDetails);
        console.log(this.serviceTypeInfo.serviceDetails)
        var newcasetypedata=this.agentscriptservice.fetchData(this.tab_title,'casetypedata')
        newcasetypedata.serviceDetails=this.serviceTypeInfo.serviceDetails
         this.agentscriptservice.updateOrInsertArray(this.tab_title,'casetypedata',newcasetypedata)
            this.dataInformation.emit();
            console.log(this.agentscriptservice.fetchData(this.tab_title,'casetypedata'))
        this.http
          .get<any>('/assets/json/' + data[i].filename)
          .subscribe((data) => {
            this.agentScriptArray = data;
            // this.agentscriptservice.updateOrInsertArray(this.tab_title,'casetypedata',data)
            // this.dataInformation.emit();
            // console.log(this.agentscriptservice.fetchData(this.tab_title,'casetypedata'))
            console.log(this.agentScriptArray, 'asa');

            this.agentScriptArray.forEach((data: any) => {
                if(data.type == "datetime"){
              if(!data.hasOwnProperty('value')){
                data.value = this.todaydate
              }
            }
            })
            item?.then.forEach((res: any) => {
              // console.log(this.agentScriptArray, 'aas');
              if (res.action == 'click') {
                // console.log(res.showElement, 'hide11');
                if (res.showElement) {
                  this.agentScriptArray.forEach((scriptItem: any) => {
                    scriptItem.visible = false;
                    if (res.showElement.includes(scriptItem.id)) {
                      scriptItem.visible = true;
                    }
                    // console.log(scriptItem, 'scriptItem1');
                    // console.log(res.showElement, 'item1');
                  });
                  // alert('1354')
                  this.listenerFn();
                  this.triggerClickEvent = false;
                }
                if(res.setFieldValue){
                  this.agentScriptArray.forEach((scriptItem: any) => {
                    res.setFieldValue.forEach((ele:any) =>{
                      if(ele.colName == scriptItem.colName){
                        scriptItem.value = ele.value
                      }
                    })
                  });
                }
                if(res.hasOwnProperty('faqkeyword')){
                  if(!this.faqkeyword)
                  this.faqkeyword = res.faqkeyword
                }
              }
            });
            if (res.showElement) {

              this.agentScriptArray.forEach((scriptItem: any) => {
                scriptItem.visible = false;
                if (res.showElement.includes(scriptItem.id)) {
                  scriptItem.visible = true;
                }
                // console.log(scriptItem, 'scriptItem1');
                // console.log(res.showElement, 'item1');
              });
              // alert("1383")
              this.listenerFn();
              this.triggerClickEvent = false;
            }

          });
        continue;
      }

      if (data[i].caseType) {
        this.loadCaseTypeScript(data[i].caseType, casetypeid, departmentid, item,res);
      }
    }
  }
  public onDropDownClose(item: any) {
  }

  public onItemSelect(event: any, item: any) {
    console.log("in checkbox")
    if (item.type == 'multifields') {
      item.subq.forEach((obj: any) => {
        if (obj.type == 'mpicklist') {
          item = obj
        }
      })
    }
    item.options.forEach((item1: any) => {
      console.log(item1.valueen,event)
      if (item1.valueen == event.valueen) {
        console.log(item1,event)
        item1.checked = true;
      }
    });
    const selectedOptions = item.options;
    this.selectedValues = selectedOptions
      .filter((opt: { checked: any }) => opt.checked)
      .map((opt: { valueen: any }) => opt.valueen);
    let e = {
      target: {
        value: this.selectedValues, // Pass the updated selected values
      }
    };
    item.value = this.selectedValues;
    this.executerule(e, item);
  }
  public onDeSelect(event: any, item: any) {
    if (item.type == 'multifields') {
      item.subq.forEach((obj: any) => {
        if (obj.type == 'mpicklist') {
          item = obj
        }
      })
    }
    // Find the deselected value and update the checked property
    for (let i = 0; i < item.options?.length; i++) {
      if (item.options[i].valueen === event.valueen) {
        item.options[i].checked = false; // Toggle the checked property to false for the deselected item
        break; // Exit the loop once the item is found and updated
      }
    }
    // Update this.selectedValues based on remaining selected values
    this.selectedValues = item.options
      .filter((opt: { checked: any }) => opt.checked)
      .map((opt: { valueen: any }) => opt.valueen);
    let e = {
      target: {
        value: this.selectedValues, // Pass the updated selected values
      }
    };
    item.value = this.selectedValues;
    this.executerule(e, item);
  }

  public onSelectAll(items: any) {
  }
  public onDeSelectAll(items: any) {
  }
  setvalue(e: any, item: any, obj: any) {
    this.agentScriptArray.forEach((obj: any) => {
      if (item.id.includes(obj.id)) {
        if (obj.type === 'multipicklist') {
          if (item.value === '') {
            obj.options.forEach((i: any) => {
              obj.value = '';
              obj.visible = true;
            })
          }else{}
        }
      }

    });
  }

}
